"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Search_1 = __importDefault(require("./pages/Search"));
const react_select_1 = __importDefault(require("react-select"));
const axios_1 = __importDefault(require("axios"));
const Statistics_1 = __importDefault(require("./pages/Statistics"));
const SearchPage_1 = __importDefault(require("./states/SearchPage"));
const mobx_react_lite_1 = require("mobx-react-lite");
const Graph_1 = __importDefault(require("./pages/Graph"));
const StackedColumnChart_1 = __importDefault(require("./pages/StackedColumnChart"));
const SearchPage_2 = __importDefault(require("./states/SearchPage"));
const ChartCustomizationModal_1 = __importDefault(require("./components/ChartCustomizationModal"));
const react_spinner_material_1 = __importDefault(require("react-spinner-material"));
const translate_1 = require("./helper/translate");
const filterKey = (item, data, typeFieldMap) => {
    return data.every(level => {
        let field = item[typeFieldMap[level.key]];
        if (field === null)
            return false;
        if (typeof field === "string") {
            try {
                if (level.key === "years") {
                    const year = new Date(field).getFullYear();
                    return Number(year) === Number(level.value);
                }
                if (level.key === "regions") {
                    return field === level.value;
                }
                field = JSON.parse(field);
            }
            catch (error) {
                console.error("Error parsing JSON:", error);
                return false;
            }
        }
        if (typeof field === "number") {
            return field === Number(level.value);
        }
        if (Array.isArray(field)) {
            return field.includes(Number(level.value));
        }
        return Number(field) === Number(level.value);
    });
};
const TabPanel = (0, mobx_react_lite_1.observer)(() => {
    var _a;
    const [activeTab, setActiveTab] = (0, react_1.useState)("search");
    const [selectedBenchmark, setSelectedBenchmark] = (0, react_1.useState)(0);
    const [filters, setFilters] = (0, react_1.useState)({});
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [showPopup, setShowPopup] = (0, react_1.useState)(false);
    const [editMode, setEditMode] = (0, react_1.useState)(false);
    const [graphColor, setGraphColor] = (0, react_1.useState)(["#9b20d9", "#00f194"]);
    const [stackedColumnChartColors, setStackedColumnChartColors] = (0, react_1.useState)([]);
    const [startOffset, setStartOffset] = (0, react_1.useState)(0);
    const [isOffsetSeted, setIsOffsetSeted] = (0, react_1.useState)(false);
    const [openCustomize, setOpenCustomize] = (0, react_1.useState)(false);
    const [chartsData, setChartsData] = (0, react_1.useState)({
        level1: [],
        level2: { series: [], categories: [] }
    });
    const [showResults, setShowResults] = (0, react_1.useState)(false);
    const graphFilters = [
        {
            value: "default",
            label: (0, translate_1.translate)("Default"),
        },
        {
            value: "increase",
            label: (0, translate_1.translate)("Increase"),
        },
        {
            value: "decrease",
            label: ("Decrease"),
        },
    ];
    const [selectedGraphFilter, setSelectedGraphFilter] = (0, react_1.useState)(graphFilters[0]);
    const getTableColumns = (0, react_1.useCallback)((key) => {
        return Object.assign(Object.assign({ key: key }, SearchPage_1.default.filters[key]), SearchPage_2.default.columnList.statisticResults[key]);
    }, [SearchPage_1.default.filters, SearchPage_2.default.columnList.statisticResults]);
    // const handleClosePopup = () => {
    //     SearchPage.setReGetResult(true);
    //     setShowPopup(false);
    // };
    const [chartConfig, setChartConfig] = (0, react_1.useState)({
        width: null,
        height: null,
        barWidth: null,
        barSpacing: null,
        title: ((_a = getTableColumns(SearchPage_2.default.getLevelValue("level1"))) === null || _a === void 0 ? void 0 : _a.title) || "",
        subtitle: SearchPage_2.default.getLevelValue("criteria") || "number"
    });
    const applyThreshold = (value, threshold, isThresholdSet) => {
        if (!isThresholdSet)
            return value;
        const numericValue = parseFloat(value);
        const [min, max] = threshold;
        if (min === '' && max === '') {
            // Neither min nor max is set, return the value as is
            return value;
        }
        if (!isNaN(numericValue)) {
            if (min !== '' && max === '') { // Only min is set
                if (numericValue < parseFloat(min)) {
                    return "-";
                }
            }
            else if (min === '' && max !== '') { // Only max is set
                if (numericValue > parseFloat(max)) {
                    return "-";
                }
            }
            else if (min !== '' && max !== '') { // Both min and max are set
                if (numericValue < parseFloat(min) || numericValue > parseFloat(max)) {
                    return "-";
                }
            }
        }
        return value;
    };
    (0, react_1.useEffect)(() => {
        var _a, _b;
        const filteredCountries = (_b = (_a = filters === null || filters === void 0 ? void 0 : filters.countries) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.filter(({ countryGrouping }) => countryGrouping.some(({ id }) => SearchPage_1.default.filters.countryGroupingOptions.options.some(({ value }) => value === id)));
        if (filteredCountries) {
            SearchPage_1.default.filters = Object.assign(Object.assign({}, SearchPage_1.default.filters), { countries: Object.assign(Object.assign({}, SearchPage_1.default.filters.countries), { options: filteredCountries }) });
        }
    }, [SearchPage_1.default.filters.countryGroupingOptions]);
    const getResult = (0, react_1.useCallback)((columnValue = null, level1Value = null, level2Value = null, level3Value = null, selectedBenchmark = 1) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const selectedDDL = [];
        const column = getTableColumns(SearchPage_2.default.getLevelValue("column").includes("union") ? "countries" : SearchPage_2.default.getLevelValue("column")), treshold = SearchPage_2.default.getLevelValue("treshold"), isTresholdSeted = SearchPage_2.default.getLevelValue("isTresholdSeted"), level1 = getTableColumns(SearchPage_2.default.getLevelValue("level1").includes("union") ? "countries" : SearchPage_2.default.getLevelValue("level1")), level2 = getTableColumns(SearchPage_2.default.getLevelValue("level2").includes("union") ? "countries" : SearchPage_2.default.getLevelValue("level2")), level3 = getTableColumns(SearchPage_2.default.getLevelValue("level3").includes("union") ? "countries" : SearchPage_2.default.getLevelValue("level3")), criteria = SearchPage_2.default.getLevelValue("criteria") || "number", results = SearchPage_2.default.results;
        const kpiID = (_a = results.find(({ id }) => id === level1Value)) === null || _a === void 0 ? void 0 : _a.attributes.kpi_id;
        // level1.options.every(({region}) => )
        if (!!column.key)
            selectedDDL.push({ key: column.key, value: columnValue });
        if (!!level1.key)
            selectedDDL.push({ key: level1.key, value: level1Value });
        if (!!level2.key)
            selectedDDL.push({ key: level2.key, value: level2Value });
        if (!!level3.key)
            selectedDDL.push({ key: level3.key, value: level3Value });
        const isKpiColumn = ["kpis"].includes(column.key) ||
            ["kpis"].includes(level1.key) ||
            ["kpis"].includes(level2.key) ||
            ["kpis"].includes(level3.key);
        const isYearColumn = ["years"].includes(column.key) ||
            ["years"].includes(level1.key) ||
            ["years"].includes(level2.key) ||
            ["years"].includes(level3.key);
        const isCountryColumn = ["countries"].includes(column.key) ||
            ["countries"].includes(level1.key) ||
            ["countries"].includes(level2.key) ||
            ["countries"].includes(level3.key) ||
            column.key.includes("union") ||
            level1.key.includes("union") ||
            level2.key.includes("union") ||
            level3.key.includes("union");
        const isDisaggregationColumn = column.key.includes('disaggregation') ||
            level1.key.includes('disaggregation') ||
            level2.key.includes('disaggregation') ||
            level3.key.includes('disaggregation');
        const countryMultiplierList = ['countryGrouping', 'regions'];
        const kpiMultiplierList = ['performanceDimensions', 'primaryExpectedOutcomes', 'wcoTools', 'sdgs'];
        const [kpiCount, yearCount, countryCount, benchmarkResults, countryMultiplierCount, countryMultiplierCountWithGroups, kpiMultiplierCount, kpiMultiplierWithWcoCount, primaryExpectedOutcomes, benchmarks,] = [
            SearchPage_2.default.columnList.statisticResults.kpi_count,
            SearchPage_2.default.columnList.statisticResults.year_count,
            SearchPage_2.default.columnList.statisticResults.country_count,
            SearchPage_2.default.columnList.statisticResults.benchmarkResults,
            SearchPage_2.default.columnList.statisticResults.countries_multiplier_count,
            SearchPage_2.default.columnList.statisticResults.countries_multiplier_count_groupings,
            SearchPage_2.default.columnList.statisticResults.kpis_multiplier_count,
            SearchPage_2.default.columnList.statisticResults.kpis_multiplier_count_w_tools,
            SearchPage_2.default.columnList.statisticResults.primary_expected_outcome_count,
            SearchPage_2.default.columnList.statisticResults.benchmarks,
        ];
        const filteredResults = results.filter((result) => filterKey(result.attributes, selectedDDL, SearchPage_2.default.columnList.typeFieldMap));
        if (criteria === "result") {
            return ((_b = filteredResults.map((result) => {
                var _a;
                if (isDisaggregationColumn) {
                    const disaggregation = selectedDDL.find(item => item.key.includes('disaggregation'));
                    return result.attributes.disaggregation_results[disaggregation === null || disaggregation === void 0 ? void 0 : disaggregation.value] ? result.attributes.disaggregation_results[disaggregation === null || disaggregation === void 0 ? void 0 : disaggregation.value]
                        +
                            " " +
                        result.attributes.results_unit : '-';
                }
                else if (applyThreshold(result.attributes.result, treshold, isTresholdSeted) === "-") {
                    return "-";
                }
                else {
                    return (((_a = result.attributes.result) === null || _a === void 0 ? void 0 : _a.toString()) +
                        " " +
                        result.attributes.results_unit);
                }
            })[0]) !== null && _b !== void 0 ? _b : "-");
        }
        else if (criteria === "benchmark") {
            const filteredBenchmarkData = benchmarkResults.filter((item) => item.benchmark_id === selectedBenchmark);
            const resultArray = filteredResults.map((dataItem) => {
                let finalResult = "-";
                const benchmarkItem = filteredBenchmarkData.find((benchItem) => benchItem.kpi_input_id ===
                    dataItem.attributes.kpi_input_id);
                if (benchmarkItem) {
                    let result = ((dataItem.attributes.result - benchmarkItem.result) /
                        dataItem.attributes.result) *
                        100;
                    if (isFinite(result)) {
                        finalResult =
                            applyThreshold(result.toFixed(2), treshold, isTresholdSeted) === "-"
                                ? "-"
                                : result >= 0
                                    ? "+ " + result.toFixed(2).toString() + " %"
                                    : result.toFixed(2).toString() + " %";
                    }
                }
                return finalResult;
            });
            return (_c = resultArray[0]) !== null && _c !== void 0 ? _c : "-";
        }
        else if (criteria === "average") {
            let unit = filteredResults.length > 0
                ? filteredResults[0].attributes.results_unit
                : "";
            let removingCount = 0;
            let sums = filteredResults
                .map((result) => {
                var _a, _b, _c, _d, _e;
                if (isDisaggregationColumn) {
                    const disaggregation = selectedDDL.find(item => item.key.includes('disaggregation'));
                    if (((_b = (_a = result.attributes) === null || _a === void 0 ? void 0 : _a.disaggregation_results) === null || _b === void 0 ? void 0 : _b[disaggregation === null || disaggregation === void 0 ? void 0 : disaggregation.value]) === false) {
                        removingCount++;
                    }
                    const resultString = ((_d = (_c = result.attributes) === null || _c === void 0 ? void 0 : _c.disaggregation_results) === null || _d === void 0 ? void 0 : _d[disaggregation === null || disaggregation === void 0 ? void 0 : disaggregation.value])
                        ? (_e = result.attributes.disaggregation_results[disaggregation === null || disaggregation === void 0 ? void 0 : disaggregation.value]) === null || _e === void 0 ? void 0 : _e.toString()
                        : '0';
                    const numberString = resultString.replace(/,/g, "."); // Replace commas with dots
                    const number = parseFloat(numberString); // Convert to a floating-point number
                    return isNaN(number) ? null : number; // Use null to indicate invalid numbers, avoiding influence on valid sums
                }
                else { // Explicitly treating result.attributes.result as a string; consider additional checks for robustness
                    const resultString = result.attributes.result.toString();
                    const numberString = resultString.replace(/,/g, "."); // Replace commas with dots
                    const number = parseFloat(numberString); // Convert to a floating-point number
                    return isNaN(number) ? null : number; // Use null to indicate invalid numbers, avoiding influence on valid sums
                }
            })
                .filter((number) => number !== null); // Asserting that filter results in number[]
            let validateValue = '0';
            if (sums.reduce((sum, a) => sum + a, 0) === 0 || (sums.length - removingCount === 0)) {
                validateValue = '0';
            }
            else {
                validateValue = (sums.reduce((partialSum, a) => partialSum + a, 0) / (sums.length - removingCount)).toFixed(2);
            }
            let average = '0';
            if (sums.reduce((sum, a) => sum + a, 0) === 0 || (sums.length - removingCount === 0)) {
                average = '0';
            }
            else {
                average = (sums.reduce((sum, a) => sum + a, 0) / (sums.length - removingCount)).toFixed(2);
            }
            return sums.length > 0 && applyThreshold(average, treshold, isTresholdSeted) !== "-"
                ? validateValue + " " + unit
                : "-";
        }
        else if (selectedDDL.length > 0) {
            const len = filteredResults.length;
            if (criteria === "percentage" || criteria === "fraction") {
                const matchedCountryMultipliers = selectedDDL.filter(item => countryMultiplierList.some(multiplier => item.key.startsWith(multiplier)));
                const matchedKpiMultipliers = kpiMultiplierList.filter(multiplier => selectedDDL.some(item => item.key === multiplier));
                let allPossibleCount = kpiCount * countryCount * yearCount;
                if (matchedCountryMultipliers.length > 0) {
                    if (matchedCountryMultipliers.length == 1) {
                        if (matchedCountryMultipliers[0].key.includes('countryGrouping')) {
                            let filteredItems = countryMultiplierCountWithGroups.filter((item) => item.grouping_option_id === matchedCountryMultipliers[0].value);
                            let totalCount = filteredItems.reduce((sum, item) => sum + item.count, 0);
                            if (!isCountryColumn) {
                                allPossibleCount = totalCount * allPossibleCount / countryCount;
                            }
                            else {
                                let countryItem = selectedDDL.find((item) => item.key === "countries");
                                let country = SearchPage_1.default.filters.countries.options.find(option => option.value === (countryItem === null || countryItem === void 0 ? void 0 : countryItem.value));
                                allPossibleCount = ((_d = country === null || country === void 0 ? void 0 : country.countryGrouping) === null || _d === void 0 ? void 0 : _d.some(item => item.id === matchedCountryMultipliers[0].value)) ? allPossibleCount : 0;
                            }
                        }
                        if (matchedCountryMultipliers[0].key == 'regions') {
                            let filteredItems = countryMultiplierCount.filter((item) => item.region === matchedCountryMultipliers[0].value);
                            let totalCount = filteredItems.reduce((sum, item) => sum + item.count, 0);
                            if (!isCountryColumn) {
                                allPossibleCount = totalCount * allPossibleCount / countryCount;
                            }
                            else {
                                let countryItem = selectedDDL.find((item) => item.key === "countries");
                                let country = SearchPage_1.default.filters.countries.options.find(option => option.value === (countryItem === null || countryItem === void 0 ? void 0 : countryItem.value));
                                allPossibleCount = (country === null || country === void 0 ? void 0 : country.region) === matchedCountryMultipliers[0].value ? allPossibleCount : 0;
                            }
                        }
                    }
                    if (matchedCountryMultipliers.length > 1) {
                        let regions = matchedCountryMultipliers.find(item => item.key === "regions");
                        let countryGroupings = matchedCountryMultipliers.find(item => item.key !== "regions");
                        let filteredItems = countryMultiplierCountWithGroups.filter((item) => (item.grouping_option_id === (countryGroupings === null || countryGroupings === void 0 ? void 0 : countryGroupings.value) && item.region === (regions === null || regions === void 0 ? void 0 : regions.value)));
                        let totalCount = filteredItems.reduce((sum, item) => sum + item.count, 0);
                        if (!isCountryColumn) {
                            allPossibleCount = totalCount * allPossibleCount / countryCount;
                        }
                        else {
                            let countryItem = selectedDDL.find((item) => item.key === "countries");
                            let country = SearchPage_1.default.filters.countries.options.find(option => option.value === (countryItem === null || countryItem === void 0 ? void 0 : countryItem.value));
                            allPossibleCount = ((_e = country === null || country === void 0 ? void 0 : country.countryGrouping) === null || _e === void 0 ? void 0 : _e.some(item => item.id === matchedCountryMultipliers[0].value)) ? allPossibleCount : 0;
                        }
                        if (matchedCountryMultipliers[0].key == 'regions') {
                            let filteredItems = countryMultiplierCount.filter((item) => item.region === matchedCountryMultipliers[0].value);
                            let totalCount = filteredItems.reduce((sum, item) => sum + item.count, 0);
                            if (!isCountryColumn) {
                                allPossibleCount = totalCount * allPossibleCount / countryCount;
                            }
                            else {
                                let countryItem = selectedDDL.find((item) => item.key === "countries");
                                let country = SearchPage_1.default.filters.countries.options.find(option => option.value === (countryItem === null || countryItem === void 0 ? void 0 : countryItem.value));
                                allPossibleCount = (country === null || country === void 0 ? void 0 : country.region) == matchedCountryMultipliers[0].value ? allPossibleCount : 0;
                            }
                        }
                    }
                }
                if (matchedKpiMultipliers.length > 0) {
                    let filteredItems = matchedKpiMultipliers.includes('wcoTools') ? kpiMultiplierWithWcoCount : kpiMultiplierCount;
                    matchedKpiMultipliers.forEach((multiplier) => {
                        const object = selectedDDL.find(item => item.key === multiplier);
                        if (multiplier == 'performanceDimensions') {
                            filteredItems = filteredItems.filter((item) => item.performance_dimension_id === object.value);
                        }
                        if (multiplier == 'primaryExpectedOutcomes') {
                            filteredItems = filteredItems.filter((item) => item.expected_outcome_id === object.value);
                        }
                        if (multiplier == 'wcoTools') {
                            filteredItems = filteredItems.filter((item) => item.wco_tool_id === object.value);
                        }
                        if (multiplier == 'sdgs') {
                            filteredItems = filteredItems.filter((item) => item.sdg_id === object.value);
                        }
                    });
                    let totalCount = matchedKpiMultipliers.includes('primaryExpectedOutcomes') ? (_f = filteredItems[0]) === null || _f === void 0 ? void 0 : _f.count : filteredItems.reduce((sum, item) => sum + item.count, 0);
                    if (matchedKpiMultipliers.includes('performanceDimensions')) {
                        const groupedData = Object.values(filteredItems.reduce((acc, item) => {
                            const key = `${item.performance_dimension_id}-${item.expected_outcome_id}`;
                            if (primaryExpectedOutcomes.length && !primaryExpectedOutcomes.includes(item.expected_outcome_id)) {
                                return acc;
                            }
                            if (!acc[key]) {
                                acc[key] = item;
                            }
                            return acc;
                        }, {}));
                        totalCount = groupedData.reduce((sum, item) => sum + item.count, 0);
                    }
                    if (!isKpiColumn) {
                        allPossibleCount = totalCount * allPossibleCount / kpiCount;
                    }
                    else {
                        let kpiItem = selectedDDL.find(item => item.key === 'kpis');
                        let selectedKPI = SearchPage_1.default.filters.kpis.options.find(option => option.value === (kpiItem === null || kpiItem === void 0 ? void 0 : kpiItem.value));
                        let isMultiplying = false;
                        if (matchedKpiMultipliers.includes('wcoTools')) {
                            const wcoTool = selectedDDL.find(item => item.key === 'wcoTools');
                            isMultiplying = (_h = (_g = selectedKPI === null || selectedKPI === void 0 ? void 0 : selectedKPI.wco_tools) === null || _g === void 0 ? void 0 : _g.includes(wcoTool === null || wcoTool === void 0 ? void 0 : wcoTool.value)) !== null && _h !== void 0 ? _h : false;
                        }
                        if (matchedKpiMultipliers.includes('performanceDimensions')) {
                            const performanceDimension = selectedDDL.find(item => item.key === 'performanceDimensions');
                            isMultiplying = (_j = (selectedKPI === null || selectedKPI === void 0 ? void 0 : selectedKPI.performance_dimension_id) == (performanceDimension === null || performanceDimension === void 0 ? void 0 : performanceDimension.value)) !== null && _j !== void 0 ? _j : false;
                        }
                        if (matchedKpiMultipliers.includes('primaryExpectedOutcomes')) {
                            const primaryExpectedOutcome = selectedDDL.find(item => item.key === 'primaryExpectedOutcomes');
                            isMultiplying = (_k = (selectedKPI === null || selectedKPI === void 0 ? void 0 : selectedKPI.primary_expected_outcome) == (primaryExpectedOutcome === null || primaryExpectedOutcome === void 0 ? void 0 : primaryExpectedOutcome.value)) !== null && _k !== void 0 ? _k : false;
                        }
                        if (matchedKpiMultipliers.includes('sdgs')) {
                            const sdg = selectedDDL.find(item => item.key === 'sdgs');
                            isMultiplying = (_m = (_l = selectedKPI === null || selectedKPI === void 0 ? void 0 : selectedKPI.sdgs) === null || _l === void 0 ? void 0 : _l.includes(sdg === null || sdg === void 0 ? void 0 : sdg.value)) !== null && _m !== void 0 ? _m : false;
                        }
                        allPossibleCount = isMultiplying ? allPossibleCount : 0;
                    }
                }
                allPossibleCount /=
                    (isKpiColumn ? kpiCount : 1) *
                        (isCountryColumn ? countryCount : 1) *
                        (isYearColumn ? yearCount : 1);
                if (criteria === "fraction") {
                    if (level1.key === "countries" && (column.key === "regions" || column.key === "countryGrouping-11")) {
                        return len === 0
                            ? "-"
                            : `${len}/${allPossibleCount}`;
                    }
                    // Return the fraction or '-' directly.
                    return (applyThreshold(len, treshold, isTresholdSeted) === "-" || !allPossibleCount)
                        ? "-"
                        : `${len}/${allPossibleCount}`;
                }
                else {
                    // Calculate the percentage, ensuring no division by zero.
                    return len > 0
                        ? applyThreshold(((len * 100) / allPossibleCount).toFixed(2), treshold, isTresholdSeted) === "-"
                            ? "-"
                            : ((len * 100) / allPossibleCount).toFixed(2) + "%"
                        : "-";
                }
            }
            return len > 0 ? applyThreshold(len, treshold, isTresholdSeted) : "-";
        }
        return "-";
    }, []);
    function sortByIncreasingY(data) {
        return data.sort((a, b) => a.y - b.y);
    }
    function sortByDecreasingY(data) {
        return data.sort((a, b) => b.y - a.y);
    }
    const getColumnChartData = (0, react_1.useCallback)(() => {
        var _a;
        const level1Data = (_a = SearchPage_2.default.displayedResult) !== null && _a !== void 0 ? _a : [];
        const criteria = SearchPage_2.default.getLevelValue("criteria") || "number";
        const hideEmptyValues = SearchPage_2.default.getLevelValue("hideEmptyValues");
        const columnChartData = level1Data.map((option) => {
            let yValue;
            let fractionString = "";
            switch (criteria) {
                case "number":
                    yValue = parseFloat(String(getResult(null, option.value, null, null)));
                    fractionString = yValue.toString();
                    break;
                case "fraction":
                    fractionString = getResult(null, option.value, null, null);
                    const [numerator] = fractionString.split("/").map(Number);
                    yValue = numerator;
                    break;
                case "percentage":
                    const result = getResult(null, option.value, null, null);
                    if (typeof result === "string") {
                        yValue = parseFloat(result.replace("%", ""));
                    }
                    fractionString = result;
                    break;
                case "result":
                case "average":
                    yValue = parseFloat(String(getResult(null, option.value, null, null)));
                    break;
                default:
                    yValue = 0;
            }
            return {
                name: option.label,
                y: yValue,
                fractionString,
            };
        });
        const filteredData = hideEmptyValues ? columnChartData.filter(({ y }) => y) : columnChartData;
        if (selectedGraphFilter.value === "increase") {
            return sortByIncreasingY(filteredData);
        }
        else if (selectedGraphFilter.value === "decrease") {
            return sortByDecreasingY(filteredData);
        }
        else {
            return filteredData;
        }
    }, [SearchPage_2.default, selectedGraphFilter, getResult]);
    const getLevel2ChartData = (0, react_1.useCallback)(() => {
        var _a, _b;
        const level1Data = (_a = SearchPage_2.default.displayedResult) !== null && _a !== void 0 ? _a : [];
        const hideEmptyValues = SearchPage_2.default.getLevelValue("hideEmptyValues");
        const columnData = (_b = getTableColumns(SearchPage_2.default.getLevelValue("column")).options) !== null && _b !== void 0 ? _b : [];
        const criteria = SearchPage_2.default.getLevelValue("criteria") || "number";
        let columnTitles = [];
        let chartData = level1Data.map((level1Option) => {
            const dataForLevel1 = columnData.map((columnOption) => {
                if (!columnTitles.includes(columnOption.label)) {
                    columnTitles.push(columnOption.label);
                }
                let value;
                let fractionString = "";
                // Handle criteria similar to getColumnChartData
                switch (criteria) {
                    case "number":
                        value = parseFloat(String(getResult(columnOption.value, level1Option.value, null)));
                        fractionString = value.toString();
                        break;
                    case "fraction":
                        fractionString = getResult(columnOption.value, level1Option.value, null);
                        const [numerator] = fractionString.split("/").map(Number);
                        value = numerator;
                        break;
                    case "percentage":
                        const result = getResult(columnOption.value, level1Option.value, null);
                        if (typeof result === "string") {
                            value = parseFloat(result.replace("%", ""));
                        }
                        fractionString = result;
                        break;
                    case "result":
                    case "average":
                        value = parseFloat(String(getResult(columnOption.value, level1Option.value, null)));
                        fractionString = value.toString();
                        break;
                    default:
                        value = 0;
                        fractionString = "0";
                }
                // Return an object with y and fractionString
                return {
                    y: value,
                    fractionString,
                };
            });
            return {
                name: level1Option.label,
                data: dataForLevel1,
            };
        });
        // Handle hideEmptyValues logic
        if (hideEmptyValues) {
            const allValuesAreZeroOrNull = (index) => chartData.every((item) => !item.data[index].y);
            const validIndices = columnTitles.reduce((acc, _, index) => {
                if (!allValuesAreZeroOrNull(index)) {
                    acc.push(index);
                }
                return acc;
            }, []);
            columnTitles = validIndices.map((index) => columnTitles[index]);
            chartData = chartData.map((item) => ({
                name: item.name,
                data: validIndices.map((index) => item.data[index]),
            }));
        }
        // Sorting logic remains the same
        const sumColumnData = (index) => chartData.reduce((sum, item) => sum + (Number.isFinite(item.data[index].y) ? item.data[index].y : 0), 0);
        let indicesSorted = Array.from(columnTitles.keys());
        if (selectedGraphFilter && selectedGraphFilter.value === "increase") {
            indicesSorted.sort((a, b) => sumColumnData(a) - sumColumnData(b));
        }
        else if (selectedGraphFilter && selectedGraphFilter.value === "decrease") {
            indicesSorted.sort((a, b) => sumColumnData(b) - sumColumnData(a));
        }
        const sortedColumnTitles = indicesSorted.map((index) => columnTitles[index]);
        chartData = chartData.map((item) => ({
            name: item.name,
            data: indicesSorted.map((index) => item.data[index]),
        }));
        return { series: chartData, categories: sortedColumnTitles };
    }, [SearchPage_2.default, selectedGraphFilter, getResult]);
    console.log(SearchPage_1.default.results);
    (0, react_1.useEffect)(() => {
        setIsLoading(true);
        axios_1.default.get(`/api/search/getFiltersList/${SearchPage_1.default.locale}`).then((resp) => {
            let filtersData = resp.data.data;
            setFilters(filtersData);
            setIsLoading(false);
        });
    }, []);
    const handleTitleChange = (event) => {
        setChartConfig(Object.assign(Object.assign({}, chartConfig), { title: event.target.value }));
    };
    const handleSubtitleChange = (event) => {
        setChartConfig(Object.assign(Object.assign({}, chartConfig), { subtitle: event.target.value }));
    };
    (0, react_1.useEffect)(() => {
        var _a, _b, _c;
        if (activeTab === "graph") {
            const level1Data = (_a = SearchPage_2.default.displayedResult) !== null && _a !== void 0 ? _a : [];
            const level2Data = (_b = SearchPage_2.default.getLevelValue("level2")) !== null && _b !== void 0 ? _b : [];
            const columnData = (_c = getTableColumns(SearchPage_2.default.getLevelValue("column")).options) !== null && _c !== void 0 ? _c : [];
            if (level1Data.length > 0 && columnData.length === 0) {
                setChartsData((state) => (Object.assign(Object.assign({}, state), { level1: getColumnChartData(), currentLevel: 1 })));
            }
            else if (level1Data.length > 0 && columnData.length > 0 && !level2Data) {
                setChartsData((state) => (Object.assign(Object.assign({}, state), { level2: getLevel2ChartData(), currentLevel: 2 })));
            }
            ;
        }
    }, [activeTab, selectedGraphFilter, startOffset, getColumnChartData, getLevel2ChartData]);
    const level1Chart = (0, react_1.useMemo)(() => {
        var _a, _b;
        const level1Data = (_a = SearchPage_2.default.displayedResult) !== null && _a !== void 0 ? _a : [];
        const columnData = (_b = getTableColumns(SearchPage_2.default.getLevelValue("column")).options) !== null && _b !== void 0 ? _b : [];
        if (level1Data.length === 0 || (level1Data.length > 0 && columnData.length > 0))
            return null;
        return (0, jsx_runtime_1.jsx)(Graph_1.default, { data: chartsData.level1, colors: graphColor, startOffset: startOffset, chartOptions: chartConfig, setChartConfig: setChartConfig });
    }, [chartsData, graphColor, startOffset, chartConfig.barSpacing, chartConfig.barWidth, chartConfig.height, chartConfig.width]);
    const level2Chart = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        const level1Data = (_a = SearchPage_2.default.displayedResult) !== null && _a !== void 0 ? _a : [];
        const level2Data = (_b = SearchPage_2.default.getLevelValue("level2")) !== null && _b !== void 0 ? _b : [];
        const columnData = (_c = getTableColumns(SearchPage_2.default.getLevelValue("column")).options) !== null && _c !== void 0 ? _c : [];
        if (!level1Data.length || !columnData.length || (level1Data.length > 0 && columnData.length === 0) || (level1Data.length > 0 && columnData.length > 0 && level2Data.length > 0))
            return null;
        //
        return (0, jsx_runtime_1.jsx)(StackedColumnChart_1.default, { data: chartsData.level2, startOffset: startOffset, chartOptions: chartConfig, setChartConfig: setChartConfig, setColors: setStackedColumnChartColors, colors: stackedColumnChartColors });
    }, [chartsData, stackedColumnChartColors, startOffset, chartConfig.barSpacing, chartConfig.barWidth, chartConfig.height, chartConfig.width]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col justify-center", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex justify-center border-b", children: [(0, jsx_runtime_1.jsx)("button", { onClick: () => setActiveTab("search"), className: `py-2 px-4 focus:outline-none ${activeTab === "search"
                            ? "border-b-2 border-blue-500 text-blue-600"
                            : "text-gray-600"}`, children: (0, translate_1.translate)("Search Result") }), !!(SearchPage_1.default.results.length) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("button", { onClick: () => setActiveTab("statistics"), className: `py-2 px-4 focus:outline-none ${activeTab === "statistics"
                                    ? "border-b-2 border-blue-500 text-blue-600"
                                    : "text-gray-600"}`, children: (0, translate_1.translate)("Statistics Result") }), (0, jsx_runtime_1.jsx)("button", { onClick: () => setActiveTab("graph"), className: `py-2 px-4 focus:outline-none ${activeTab === "graph"
                                    ? "border-b-2 border-blue-500 text-blue-600"
                                    : "text-gray-600"}`, children: (0, translate_1.translate)("Graph") })] }))] }), isLoading && ((0, jsx_runtime_1.jsx)("div", { className: "spinner-container mt-2", children: (0, jsx_runtime_1.jsx)(react_spinner_material_1.default, { color: "#333", visible: true }) })), (0, jsx_runtime_1.jsxs)("div", { className: "p-1", children: [activeTab === "search" && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(Search_1.default, { filters: filters }) })), activeTab === "statistics" && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(Statistics_1.default, { getResult: getResult, showResults: showResults, setShowResults: setShowResults, selectedBenchmark: selectedBenchmark, setSelectedBenchmark: setSelectedBenchmark }) })), activeTab === "graph" && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { style: {
                                    display: "flex",
                                    alignItems: "center"
                                }, children: [(0, jsx_runtime_1.jsx)("div", { className: "mr-1", children: (0, jsx_runtime_1.jsx)(react_select_1.default, { defaultValue: graphFilters[0], options: graphFilters, onChange: (val) => setSelectedGraphFilter(val), value: selectedGraphFilter }) }), (0, jsx_runtime_1.jsx)("button", { onClick: () => setOpenCustomize(true), className: "btn mr-1", style: {
                                            background: "#189CD8",
                                            borderColor: "#28c76f",
                                            color: "#fff",
                                        }, children: (0, translate_1.translate)("Customize") }), (0, jsx_runtime_1.jsxs)("div", { className: "form-check text-left mr-1", children: [(0, jsx_runtime_1.jsx)("input", { className: "form-check-input", type: "checkbox", checked: isOffsetSeted, onChange: evt => setIsOffsetSeted((state) => !state) }), (0, jsx_runtime_1.jsx)("label", { className: "form-check-label", children: (0, translate_1.translate)("Use Offset Y Axis") })] }), isOffsetSeted && (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("div", { className: "mr-1", children: [(0, jsx_runtime_1.jsx)("h3", { children: (0, translate_1.translate)("Start") }), (0, jsx_runtime_1.jsx)("input", { className: "border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5", type: "number", onChange: (event) => setStartOffset(event.target.value), value: startOffset })] }) })] }), (0, jsx_runtime_1.jsxs)("div", { style: {
                                    width: 200,
                                    margin: "15px 0"
                                }, children: [(0, jsx_runtime_1.jsx)("div", { className: "mr-1 mb-1", children: (0, jsx_runtime_1.jsx)("input", { className: "border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5", type: "text", onChange: handleTitleChange, value: chartConfig.title }) }), (0, jsx_runtime_1.jsx)("div", { className: "mr-1", children: (0, jsx_runtime_1.jsx)("input", { className: "border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5", type: "text", onChange: handleSubtitleChange, value: chartConfig.subtitle }) })] }), (0, jsx_runtime_1.jsx)(ChartCustomizationModal_1.default, { gradientColors: graphColor, setGradientColors: setGraphColor, colors: stackedColumnChartColors, setColors: setStackedColumnChartColors, data: chartsData, onClose: () => setOpenCustomize(false), isOpen: openCustomize, onSave: setChartConfig, chartConfig: chartConfig }), level2Chart, level1Chart] }))] })] }));
});
exports.default = TabPanel;
